// extracted by mini-css-extract-plugin
export default {"buttonsRow":"ButtonsRow_buttonsRow__8lztb","isCentered":"ButtonsRow_isCentered__dc3Nm"};